import { lazy, Suspense } from 'react';
import Loader from '../custom/loader/main';


const Main = lazy(() => import('../components/setup/students/main'));

const Students = () => {
    return(
        <Suspense fallback={<Loader/>}>
            <Main/>
        </Suspense>
    )

}

export default Students;